package com.wintermar.inspection.feature.presentation.inspection.answer.search.widget

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import com.wintermar.inspection.core.ui.util.highlightKeywordWithTruncate
import com.wintermar.inspection.core.ui.widget.DefaultHorizontalDivider
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_arrow_right
import org.jetbrains.compose.resources.painterResource

@Composable
fun InspectionSearchResultItem(
    keyword: String,
    resultData: Pair<String, String>,
    modifier: Modifier = Modifier,
    color: ThemeColor = LocalAppTheme.current.color,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    onClick: (id: String) -> Unit
) {
    Column(
        modifier = Modifier
            .clickable { onClick(resultData.first) }
            .then(modifier)
    ) {
        Row(
            modifier = Modifier.padding(vertical = dimension.spacing.space4),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            TextBodySmall(
                annotatedString = resultData.second.highlightKeywordWithTruncate(keyword),
                modifier = Modifier.weight(1f)
            )
            Icon(
                painter = painterResource(Res.drawable.ic_arrow_right),
                tint = color.icon.subtlest,
                modifier = Modifier.size(dimension.size.icon.s),
                contentDescription = keyword
            )
        }
        DefaultHorizontalDivider()
    }
}
